// extracted by mini-css-extract-plugin
export default {"mCard":"yD-z","image":"zD-z","imageNoBackground":"AD-z","imageHasCategory":"BD-z","fullWidth":"CD-z"};